import { render } from "./Templates.vue?vue&type=template&id=53c6ff13"
import script from "./Templates.vue?vue&type=script&lang=js"
export * from "./Templates.vue?vue&type=script&lang=js"

import "./Templates.vue?vue&type=style&index=0&id=53c6ff13&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__